




































import _ from 'lodash';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';

// tslint:disable no-var-requires
const infiniteScroll = require('vue-infinite-scroll');
// tslint:enable no-var-requires

import PresetTag from '@/classes/PresetTag';
import IdBadge from '@/components/Misc/IdBadge.vue';
import IndexPresenter from '@/components/Misc/IndexPresenter.vue';
import SearchBox from '@/components/Misc/SearchBox.vue';
import TagBadge from '@/components/Misc/TagBadge.vue';
import AddForm from '@/components/PresetTag/AddForm.vue';
import EditForm from '@/components/PresetTag/EditForm.vue';
import { IApiResponseLogin, ITag } from '@/interfaces';
import { upsertList } from '@/main';
import PresetTagsModule from '@/store/modules/PresetTagsModule';

const presetTagsModule = getModule(PresetTagsModule);

export default Vue.extend({
  components: { AddForm, EditForm, IdBadge, IndexPresenter, SearchBox, TagBadge },
  directives: { infiniteScroll },
  data() {
    return {
      busy: false,
      searchBusy: false,
      isAdding: false,
      isEditing: false,
      searchText: '',
      canSearch: false,
      form: {
        editing: {
          originalCopy: new PresetTag(),
        },
      },
    };
  },
  computed: {
    displayPresettags(): PresetTag[] {
      if (this.searchText !== '') {
        const presetTags = _.filter(presetTagsModule.presettags, (presetTag: PresetTag) => {
          const searchText = this.searchText.toLowerCase();
          return presetTag.presettagid.toLowerCase().includes(searchText)
            || presetTag.name.toLowerCase().includes(searchText)
            || presetTag.tags.find((tag) => tag.name.toLowerCase().includes(searchText)) !== undefined;
        });
        return presetTags;
      }

      return presetTagsModule.presettags;
    },
    hasMore(): boolean {
      return presetTagsModule.hasMore;
    },
  },
  methods: {
    loadMore() {
      if (presetTagsModule.hasMore) {
        this.busy = true;

        presetTagsModule.apiLoadNextPage({ pageSize: 50 }).then(() => {
          this.busy = false;
        });
      }
    },
    addingStart() {
      this.isAdding = true;
    },
    addingCancelled() {
      this.isAdding = false;
    },
    addingSaved() {
      this.isAdding = false;
    },
    editingStart(presettag: PresetTag) {
      this.isEditing = true;
      this.form.editing.originalCopy = presettag;
    },
    editingCancelled() {
      this.isEditing = false;
    },
    editingSaved() {
      this.isEditing = false;
    },
    updateSearchText(searchText: string) {
      this.canSearch = true;
      this.searchText = searchText;
    },
    searchFromServer() {
      this.searchBusy = true;
      presetTagsModule.apiSearchPresetTags({ searchText: this.searchText }).then(() => {
        this.searchBusy = false;
        this.canSearch = false;
      });
    },
  },
});
